import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MainMenuButton } from '@app/models/elements/main-menu-button';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RouterService {
	activePageName: string = '';
	httpCall: Observable<MainMenuButton[]> = {} as Observable<MainMenuButton[]>;

	constructor(
		http: HttpClient,
		private router: Router,
	) {
		this.httpCall = http
			.get<MainMenuButton[]>(`${environment.contextRoot}/api/home/main-menu-buttons`)
			.pipe(shareReplay());
	}

	/**
	 * Sets active page title from the current url (from main-menu-button).
	 * @param currentUrl
	 */
	setActivePage = (currentUrl: string) => {
		this.httpCall.subscribe((links) => {
			let link = links.find((l) => currentUrl.includes(l.address));
			this.activePageName = link ? link.title : '';
		});
	};

	/* NAVIGATION METHODS */

	/**
	 * Redirects to /home
	 */
	navigateToHome = () => {
		this.activePageName = '';
		this.router.navigateByUrl('/');
	};

	/**
	 * Redirects to passed url
	 * @param url
	 */
	navigateTo = (url: string) => {
		this.router.navigateByUrl(url);
	};
}
